const objFunc = () => {
  return {
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
    cellPhoneNumber: undefined,
    email: undefined,
    dateOfBirth: undefined,
    address: undefined,
    mailingAddress: undefined,
    zip: undefined,
    mailingZip: undefined,
    idNumber: undefined,
    idExpiration: undefined,
    tin: undefined,
    incomeName: undefined,
    routingNum: undefined,
    accountNum: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
